import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { zUsdMicros } from "../currency";
import { MarketingChannel } from "../marketing";

export type BillingStats = z.infer<typeof billingStatsSchema>;
export const billingStatsSchema = z.object({
  included: z.number(),
  overage: z.number(),
  carrierFees: zUsdMicros.optional(),
  costMicros: zUsdMicros.optional(),
});

export type AutomationDetails = z.infer<typeof automationDetailsSchema>;
export const automationDetailsSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.literal("automation"),
  createdAt: z.coerce.date().optional(),
  stats: billingStatsSchema,
});

export type CampaignDetails = z.infer<typeof campaignDetailsSchema>;
export const campaignDetailsSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.literal("campaign"),
  createdAt: z.coerce.date().optional(),
  scheduledAt: z.coerce.date().optional(),
  stats: billingStatsSchema,
});

export type AutomationCampaignDetails = AutomationDetails | CampaignDetails;
export const automationCampaignDetailsSchema = z.union([
  automationDetailsSchema,
  campaignDetailsSchema,
]);

export type BillingWindowProcessingResult = z.infer<
  typeof billingWindowProcessingResultSchema
>;
export const billingWindowProcessingResultSchema = z.object({
  billingWindowId: z.string(),
  teamId: z.string(),
  channel: createEnum(MarketingChannel, { enumName: "MarketingChannel" }),
  startsAt: z.date(),
  endsAt: z.date(),
  totalIncluded: z.number(),
  totalOverage: z.number(),
  totalCarrierFees: z.number(),
  automations: z.array(automationDetailsSchema),
  campaigns: z.array(campaignDetailsSchema),
});

const overviewItemSchema = z.object({
  count: z.number(),
  costMicros: zUsdMicros,
});

export type OrderTrackingOverview = z.infer<typeof orderTrackingOverviewSchema>;
export const orderTrackingOverviewSchema = z.object({
  ordersIncluded: overviewItemSchema.optional(),
  ordersOverage: overviewItemSchema.optional(),
  smsIncluded: overviewItemSchema.optional(),
  smsOverage: overviewItemSchema.optional(),
  smsCarrierFeesMicros: zUsdMicros.optional(),
  emailIncluded: overviewItemSchema.optional(),
  emailOverage: overviewItemSchema.optional(),
});
